import React from 'react';
import { MAIN_MENU_ITEMS } from '@lib/constants';
import { useI18n } from '@lib/i18n';
import style from './index.module.scss';
import { useSelector } from 'react-redux';

const DynamicMenu = () => {
	const { locale } = useI18n();
	const { authenticated } = useSelector((state) => state.user);

	if (!MAIN_MENU_ITEMS.length) {
		return null;
	}

	const visibleMenuItems = MAIN_MENU_ITEMS.filter(
		(item) => !item.showForAuthenticatedUsersOnly || authenticated
	);

	const getMenuLabel = (item) => {
		if (item?.labels && locale && item.labels[locale]) {
			return item.labels[locale];
		}

		if (item?.labels?.en) {
			return item.labels.en;
		}

		return item.label || '';
	};

	if (!visibleMenuItems.length) {
		return null;
	}

	return (
		<nav className={style.dynamicMenu}>
			<ul className={style.dynamicList}>
				{visibleMenuItems.map((item) => (
					<li key={item.id}>
						<a href={item.url} target={item.target || undefined} rel={item.rel || undefined}>
							{getMenuLabel(item)}
						</a>
					</li>
				))}
			</ul>
		</nav>
	);
};

export default DynamicMenu;
